import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby-plugin-react-i18next';
import rehypeReact from 'rehype-react';

import { mapIcon } from '../../utils/mappers';

import ImageDisplay from '../imageDisplay';

const FourColumnSpotlightFull = ({ groupingTitle, icons = [], iconHeight = 69, cta }) => {
	const renderDescAst = new rehypeReact({
		createElement: React.createElement,
		components: {
			p: ({ children }) => (
				<p className="typography typography--body typography--secondary">
					{children}
				</p>
			),
		},
	}).Compiler;
	return (
		<div className="fc-full-spotlight section">
			<div className="section__content">
				<h2 className="typography typography--h2 typography--secondary">
					{groupingTitle}
				</h2>
				<div className="fc-full-spotlight__items">
					{icons?.map(mapIcon).map(({ title, icon, description }) => (
						<div className="ways__items-item" key={title}>
							<figure
								className="fc-full-spotlight__items-item-icon"
								style={{ height: iconHeight }}
							>
								<ImageDisplay
									alt={icon.alt}
									image={icon.data}
									src={icon.src}
								/>
							</figure>
							<h3 className="typography typography--h3 typography--secondary">
								{title}
							</h3>
							<div className="fc-full-spotlight__items-item-body">
								{renderDescAst(description)}
							</div>
						</div>
					))}
				</div>
				{cta && (
					<Link to={cta?.link}>
						<button className="btn btn--outlined">{cta?.title}</button>
					</Link>
				)}
			</div>
		</div>
	);
};

FourColumnSpotlightFull.propTypes = {
	groupingTitle: PropTypes.string.isRequired,
	icons: PropTypes.arrayOf(
		PropTypes.shape({
			icon: PropTypes.shape({
				gatsbyImageData: PropTypes.object,
				file: PropTypes.shape({ url: PropTypes.string }),
				description: PropTypes.string,
			}),
			title: PropTypes.string.isRequired,
			description: PropTypes.shape({
				childMarkdownRemark: PropTypes.shape({ html: PropTypes.object }),
			}),
		})
	).isRequired,
	iconHeight: PropTypes.number,
	cta: PropTypes.shape({
		link: PropTypes.string,
		title: PropTypes.string,
	}),
};

export default FourColumnSpotlightFull;
